import makeStyles from '@mui/styles/makeStyles';
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

import { brandSuccessColor, textColor, placeholderColor } from "../../DashMetrics/DashStyleGuides";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    "& .MuiStepper-root": {
      "& .MuiStep-root": {
        height: "160px",
        minWidth: "160px",
        "& .MuiStepLabel-root": {
          height: "100%",
          "& .MuiStepLabel-labelContainer": {
            height: "100%",
            "& .MuiStepLabel-label": {
              height: "100%",
            },
          },
        },
      },
    },
    "& .typ-label": {
      color: textColor,
      fontWeight: "bold",
      fontSize: 12,
      lineHeight: 1.6,
      fontFamily: "Manrope",
    },
    "& .typ-date": {
      fontSize: 12,
      fontWeight: "normal",
      color: placeholderColor,
      lineHeight: 1.6,
      fontFamily: "Manrope",
    },
  },
}));

export const ColorlibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: brandSuccessColor,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: brandSuccessColor,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    background:
      "repeating-linear-gradient(to right,#eaeaf0 0,#eaeaf0 15px,transparent 20px,transparent 20px)",
    borderRadius: 1,
  },
}));

export const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 42,
  height: 42,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    background: brandSuccessColor,
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    background: brandSuccessColor,
  }),
}));

export default useStyles;
